import { type MouseEvent, type FC } from 'react'
import { Button } from 'shared/ui'
import { type Conversation } from 'entities/Conversation/model/Conversation'
import { useConversationListContext } from 'pages/conversations/ui/ConversationList/context'
import { type IMarkAsNeedResponseParams } from 'pages/conversations/ui/ConversationList/store'

type IButtonMarkAsPendingProps = {
  conversation?: Conversation
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  clickCallback?: () => void
}

export const ButtonMarkAsPending: FC<IButtonMarkAsPendingProps> = ({
  conversation,
  onMouseLeave,
  onMouseEnter,
  clickCallback,
}) => {
  const store = useConversationListContext()
  const { handleMarkAsNeedResponse, selectedListIds } = store
  const handleClick = (e: MouseEvent) => {
    e.stopPropagation()
    const id = conversation?.id
    const params: IMarkAsNeedResponseParams = {
      isNeedResponse: !store.filtersStore.isPending,
      ids: id ? [id] : selectedListIds,
      isUndo: true,
    }

    handleMarkAsNeedResponse(params)
    clickCallback?.()
  }

  return (
    <Button
      fontWeight={400}
      onClick={handleClick}
      typeBtn='menuItem'
      icon={'messageCircleChecked'}
      text={store.filtersStore.isPending ? 'Mark as responded' : 'Mark as Needs Response'}
      fullWidth
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  )
}
